import React from "react";
import Cookies from "../components/cookies";

export const Context = React.createContext({});

export default class MainProvider extends React.Component {
    constructor(props) {
        super(props);

        const CookieObj = new Cookies();
        const token = CookieObj.getCookie("access_token");

        const storedUser = localStorage.getItem("user");
        let storedUserData = null;

        if (storedUser) {
            try {
                storedUserData = JSON.parse(storedUser);
            } catch (e) {
                localStorage.removeItem("user");
            }
        }

        this.state = {
            auth: !!token || !!storedUserData, // 🔥 FIX
            setValue: this.setValue,
            logout: this.logout,
            resetLogin: this.resetLogin,
            loading: false,
            sidebar_show: false,
            user_role: storedUserData ? storedUserData.user_role : "",
            user_uuid: storedUserData ? storedUserData.user_uuid : false,
            notes: "",
        };
    }

    setValue = (val) => {
        this.setState(val);
    };

    logout = () => {
        this.setState({
            auth: false,
            user_role: "",
            user_uuid: false,
        });

        localStorage.removeItem("user");

        const CookieObj = new Cookies();
        CookieObj.removeCookieBatch(["access_token"]);

        window.location.href = "/login";
    };

    resetLogin = () => {
        this.setState({ auth: false });

        const CookieObj = new Cookies();
        CookieObj.removeCookieBatch(["access_token"]);
    };

    render() {
        return (
            <Context.Provider value={this.state}>
                {this.props.children}
            </Context.Provider>
        );
    }
}
